import React from 'react';
import { PlansContext } from '@/contexts/plans';

export const usePlans = () => React.useContext(PlansContext);
